import axios from "axios";
import { config } from "../../Utils/helpers";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const AddHomeBanner = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "HOME_BANNER_ADD_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/home-banner/add`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "HOME_BANNER_ADD_SUCCESS",
          payload: data,
        });
        return Promise.resolve(data);
      } else {
        dispatch({
          type: "HOME_BANNER_ADD_FAIL",
          payload: data.message || "Add failed",
        });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({
        type: "HOME_BANNER_ADD_FAIL",
        payload: errorMessage,
      });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const UpdateHomeBanner = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "HOME_BANNER_UPDATE_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/home-banner/update`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "HOME_BANNER_UPDATE_SUCCESS",
          payload: data,
        });
        return Promise.resolve(data);
      } else {
        dispatch({
          type: "HOME_BANNER_UPDATE_FAIL",
          payload: data.message || "Update failed",
        });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({
        type: "HOME_BANNER_UPDATE_FAIL",
        payload: errorMessage,
      });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const changeHomeBannerStatus = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "CHANGE_HOME_BANNER_STATUS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/home-banner/update-status`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "CHANGE_HOME_BANNER_STATUS_SUCCESS", payload: data });
        toast.success("Changed Successfully!!");
        return data;
      } else {
        dispatch({ type: "CHANGE_HOME_BANNER_STATUS_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "CHANGE_HOME_BANNER_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};

export const GetHomeBannerList = (listData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "HOME_BANNER_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/home-banner/list`,
        listData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "HOME_BANNER_LIST_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "HOME_BANNER_LIST_FAIL",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "HOME_BANNER_LIST_FAIL",
        payload: error?.response,
      });
    }
  };
};

export const ViewHomeBanner = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "HOME_BANNER_VIEW_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/home-banner/view/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "HOME_BANNER_VIEW_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "HOME_BANNER_VIEW_FAIL",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "HOME_BANNER_VIEW_FAIL",
        payload: error?.response?.data?.message,
      });
    }
  };
};